import { ReactElement } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import Grid from '@material-ui/core/Grid';
import { AddCircleOutline } from '@mui/icons-material';

import SecondaryPhysician from './SecondaryPhysician';
import Button from '~/ui/components/common/Button';
import { getPhysicianInitialValues } from './form';
import Divider from '../Divider';
import { IOption } from '~/ui/components/inputs/Select/types';
import { IAttendingPhysician, ISecondaryPhysician } from '~/services/api/attendingPhysicians/types';
import { IPatientFormValues } from '../types';
import AttendingPhysician from './AttendingPhysician';

interface IProps {
  attendingPhysicianOptions: IOption[];
  programAttendingPhysicians: IAttendingPhysician[];
}

const PhysiciansSection = ({
  attendingPhysicianOptions,
  programAttendingPhysicians,
}: IProps): ReactElement => {
  const { control } = useFormContext<IPatientFormValues>();

  const { fields, append, remove } = useFieldArray<IPatientFormValues, 'secondaryPhysicians', ''>({
    control,
    name: 'secondaryPhysicians',
    keyName: '',
  });

  const onAdd = () => append(getPhysicianInitialValues({} as ISecondaryPhysician));

  const onRemove = (index: number) => remove(index);

  const getKey = (id: number, index: number) => `${id}-${index}`;

  return (
    <>
      <Grid container spacing={3}>
        <Grid item>
          <Divider title="Attending Physician" showDividerLine={false} />
        </Grid>
        <Grid item xs={12}>
          <AttendingPhysician
            attendingPhysicianOptions={attendingPhysicianOptions}
            programAttendingPhysicians={programAttendingPhysicians}
          />
        </Grid>
        <Grid item>
          <Divider title="Secondary Physician" showDividerLine={false} />
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            {fields.map((physician, index) => (
              <Grid item xs={12} key={getKey(physician.id, index)}>
                <SecondaryPhysician index={index} onRemove={onRemove} />
              </Grid>
            ))}
            <Grid item>
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                startIcon={<AddCircleOutline />}
                onClick={onAdd}
              >
                Add More
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default PhysiciansSection;
